module.exports =
{
	locale: 'en',
	long: require('./long.json'),
	long_time: require('./long-time.json'),
	long_convenient: require('./long-convenient.json'),
	short: require('./short.json'),
	short_time: require('./short-time.json'),
	short_convenient: require('./short-convenient.json'),
	narrow: require('./narrow.json'),
	tiny: require('./tiny.json'),
	quantify: require('./quantify')
}


//////////////////
// WEBPACK FOOTER
// ./~/javascript-time-ago/locale/en/index.js
// module id = 673
// module chunks = 0